import { render, staticRenderFns } from "./Waring.vue?vue&type=template&id=2a9bcc7c&scoped=true&"
import script from "./Waring.vue?vue&type=script&lang=js&"
export * from "./Waring.vue?vue&type=script&lang=js&"
import style0 from "./Waring.vue?vue&type=style&index=0&id=2a9bcc7c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9bcc7c",
  null
  
)

export default component.exports